import React, { useState, useRef, useEffect } from 'react';
import { Cached, Info } from '@mui/icons-material';
import './PromptAutomatorPromptTemplate.css';

const PromptAutomatorPromptTemplate = ({ value, onChange, availableTags, onSave, saving }) => {
  const editorRef = useRef(null);
  const [focused, setFocused] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  const [initialValue] = useState(value);

  // Détecter les changements
  useEffect(() => {
    setHasChanges(value !== initialValue);
  }, [value, initialValue]);

  const insertTag = (tagName) => {
    const tagText = `{${tagName}}`;
    const currentValue = value || '';
    
    // Si on peut récupérer la position du curseur
    if (editorRef.current && typeof editorRef.current.selectionStart === 'number') {
      const start = editorRef.current.selectionStart;
      const end = editorRef.current.selectionEnd;
      const newValue = currentValue.substring(0, start) + tagText + currentValue.substring(end);
      onChange(newValue);
      
      // Repositionner le curseur
      setTimeout(() => {
        if (editorRef.current) {
          editorRef.current.focus();
          const newPos = start + tagText.length;
          editorRef.current.setSelectionRange(newPos, newPos);
        }
      }, 0);
    } else {
      // Fallback : ajouter à la fin
      onChange(currentValue + tagText);
    }
  };

  const handleKeyDown = (e) => {
    // Gérer Tab pour l'indentation
    if (e.key === 'Tab') {
      e.preventDefault();
      const start = e.target.selectionStart;
      const end = e.target.selectionEnd;
      const newValue = value.substring(0, start) + '  ' + value.substring(end);
      onChange(newValue);
      
      setTimeout(() => {
        e.target.setSelectionRange(start + 2, start + 2);
      }, 0);
    }
  };

  return (
    <div className="prompt-template">

<div className="prompt-template__tags">
        <div className="prompt-template__tags-header">
          <div className="prompt-template__tags-info">
            {React.createElement(Info)}
            <span className="prompt-template__tags-subtitle">
              Add {'{tagName}'} to your prompt structure
            </span>
          </div>
        </div>
        
        <div className="prompt-template__tags-grid">
          {availableTags.map(tag => (
            <button
              key={tag.id}
              type="button"
              className="prompt-template__tag-button"
              onClick={() => insertTag(tag.id)}
              title={`Insert {${tag.id}} tag`}
            >
              <span className="tag-icon">{React.createElement(tag.icon)}</span>
              <span className="tag-name">{tag.id}</span>
            </button>
          ))}
        </div>

      </div>

      <div className={`prompt-template__editor ${focused ? 'focused' : ''}`}>
        <textarea
          ref={editorRef}
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          onFocus={() => setFocused(true)}
          onBlur={() => setFocused(false)}
          onKeyDown={handleKeyDown}
          placeholder="Write your template here... "
          className="prompt-template__textarea"
          rows={4}
          spellCheck={false}
        />
      </div>

    

      <div className="prompt-template__actions">
        <button
          onClick={() => {
            onSave();
            setHasChanges(false);
          }}
          disabled={saving || !value?.trim()}
          className={`prompt-template__save-btn ${hasChanges ? 'prompt-template__save-btn--highlighted' : ''}`}
          title={saving ? 'Saving...' : hasChanges ? 'Save changes' : 'Update Template'}
        >
          {React.createElement(Cached)}
        </button>
      </div>
    </div>
  );
};

export default PromptAutomatorPromptTemplate;